import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Collapse, createTheme, ThemeProvider, Typography } from "@mui/material";
import { SupersetConfigItem } from "../editConfigurationTypes";
import { MetaDataConfigObject } from "../../../types";

import { parse } from "../editConfiguraitonService";
import { JsonForms } from "@jsonforms/react";
import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import { JsonFormsRendererRegistryEntry, JsonSchema, UISchemaElement } from "@jsonforms/core";
// import { withHoverTracking } from "../hover/WithHoverTracking";
// import { HoverInfoPopup } from "../hover/HoverInfoPopup";
// import { HoverTrackerProvider } from "../hover/HoverTrackerContext";
import { PrimitiveEnumDropdownRenderer, primitiveEnumTester } from "../renderer/PrimitiveEnumDropdown";
import { ArrayEnumDropdownRenderer , arrayOfPrimitiveEnumTester } from "../renderer/ArrayEnumDropdownWithSort";
import { ArrayObjectPrimitiveEnumRenderer, arrayObjectPrimitiveEnumTester } from "../renderer/ArrayObjectPrimitiveEnumRendererUI";
import { Loader } from "../../loader/Loader";

//  const trackedRenderers: JsonFormsRendererRegistryEntry[] = [
//   ...materialRenderers, 
//    { tester: primitiveEnumTester, renderer: PrimitiveEnumDropdownRenderer }, 
  
//   { tester: arrayOfPrimitiveEnumTester, renderer: ArrayEnumDropdownRenderer }
// ]
// .map((r) => ({
//     tester: r.tester,
//     renderer: withHoverTracking(r.renderer),
//   }));

export interface ConfigFormBuilderProps {
  lobConfiguration: MetaDataConfigObject[];
  supersetConfiguration: SupersetConfigItem[];
  selectedDomain: string;
  selectedDomainType: string;
  formData: any;
  setFormData: (data: any) => void;
  setErrors: (errors: any) => void;
}

const ConfigFormBuilder: React.FC<ConfigFormBuilderProps> = ({
  lobConfiguration,
  supersetConfiguration,
  selectedDomain,
  selectedDomainType,
  formData,
  setFormData,
  setErrors,
}) => {
  const [ui, setUI] = useState<UISchemaElement>({} as UISchemaElement);
  const [schema, setSchema] = useState<JsonSchema>({} as JsonSchema);
  const [renderError, setRenderError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const supersetInfo = supersetConfiguration.find(
    (item) =>
      item.domainName === selectedDomain &&
      item.domainType === selectedDomainType
  );
  const lobInfo = lobConfiguration.find(
    (item) =>
      item.domainName === selectedDomain &&
      item.domainType === selectedDomainType
  );

  const handleChange = (newData: any, errors: any) => {
    setFormData(newData);
    setErrors(errors);
  };
  const format = supersetInfo?.format.replace(/\s+/g, "") ?? 
  "";
  const setStates = () => {
    setIsLoading(true);
    if (!supersetInfo) return;
    try {
      const parsedFormat = parse(lobInfo, supersetInfo);
      setUI(parsedFormat.ui as UISchemaElement);
      setSchema(parsedFormat.schema as JsonSchema);
      setFormData(parsedFormat.data);
      setRenderError(null); 
    } catch (error) {
      console.error('Error parsing configuration:', error);
      setRenderError(error instanceof Error ? error.message : 'Unknown error occurred while parsing configuration');
    }
    finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    setStates();
  }, [lobInfo, supersetInfo]);
  useEffect(() => {
    setStates();
  }, []);


  if (!supersetInfo || !supersetInfo.format ) {
    return (
      <Typography variant="h6" sx={{ mb: 2 }}>
        No data found
      </Typography>
    );
  }

  if (renderError) {
    console.error(
      "renderer error",
      renderError
    )
    return (
      <Box sx={{ p: 2, color: 'error.light', borderRadius: 1 }}>
        <Typography variant="h6" color="error" sx={{ mb: 1 }}>
          Configuration Error
        </Typography>
        <Typography variant="body2" color="error">
          {renderError}
        </Typography>
      </Box>
    );
  }
  const renderers =
  [
    ...materialRenderers, 
    { tester: primitiveEnumTester, renderer: PrimitiveEnumDropdownRenderer }, 
    { tester: arrayObjectPrimitiveEnumTester, renderer: ArrayObjectPrimitiveEnumRenderer },
    
    { tester: arrayOfPrimitiveEnumTester, renderer: ArrayEnumDropdownRenderer }
  ];
  const theme = createTheme({
    components: {
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginBottom: '20px',
          },
        },
      },
    },
  });

  try {
    return isLoading ? <Loader /> : (
      <ThemeProvider theme={theme}>
        {/* <HoverTrackerProvider> */}
        <JsonForms
          schema={schema}
          uischema={ui as UISchemaElement}
          data={formData}
          renderers={renderers}
          cells={materialCells}
          onChange={({ data , errors}) => handleChange(data,errors)}
          validationMode="NoValidation" 
        />
        {/* <HoverInfoPopup supersetInfo={supersetInfo}/> */}
        {/* </HoverTrackerProvider> */}
      </ThemeProvider>
    );
  } catch (error) {
    console.error('Error rendering JsonForms:', error);
    return (
      <Box sx={{ p: 2, bgcolor: 'error.light', borderRadius: 1 }}>
        <Typography variant="h6" color="error" sx={{ mb: 1 }}>
          Render Error
        </Typography>
        <Typography variant="body2" color="error">
          {error instanceof Error ? error.message : 'Unknown error occurred while rendering the form'}
        </Typography>
      </Box>
    );
  }
};

export default ConfigFormBuilder;
